import { render, staticRenderFns } from "./CoopHotelConfig.vue?vue&type=template&id=485fd152&scoped=true"
import script from "./CoopHotelConfig.vue?vue&type=script&lang=js"
export * from "./CoopHotelConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485fd152",
  null
  
)

export default component.exports